import posthog, { Properties } from "posthog-js";

export const documentUpload = (documentName: string, documentSize: number) => {
  capture("document_upload", { documentName, documentSize });
};

export const searchFilesAndFolders = (query: string, parent: string | undefined) => {
  capture("search_files_and_folder", { query, parent });
};

export const snapshotCreate = (template: string) => {
  capture("snapshot_create", { template });
};

export const snapshotView = (name: string) => {
  capture("snapshot_view", { name });
};

export const showSummary = (name: string) => {
  capture("show_summary", { name });
};

export const folderExport = (fseId: string) => {
  capture("folder_export", { fseId });
};

export const search = (query: string) => {
  capture("search", { query });
};

export const snapshotCollectionCreate = (name: string) => {
  capture("snapshot_collection_create", { name });
};

export const snapshotCollectionExport = (collection?: string) => {
  capture("snapshot_collection_export", { collection });
};

export const chronologyCreate = (fseId: string) => {
  capture("chronology_create", { fseId });
};

export const chronologyViewed = (fseId: string) => {
  capture("chronology_viewed", { fseId });
};

export const promptEnter = (promptText: string) => {
  capture("prompt_enter", { promptText });
};

export const sharepointLogin = () => {
  capture("sharepoint_login");
};

export const sharepointSync = (filename: string) => {
  capture("sharepoint_sync", { filename });
};

export const identify = (user: string) => {
  identify(user);
};

export const snapshotSearch = (query: string) => {
  capture("snapshot_search", { query });
};

export const snapshotQa = (query: string) => {
  capture("snapshot_qa", { query });
};

export const improvePromptSendToChat = (prompt: string) => {
  capture("improve_prompt_send_to_chat", { prompt });
};

export const twoFactorAuthentication = (user: string) => {
  capture("two_factor_authentication", { user });
};

export const init = () => {
  const POSTHOG_KEY = "__POSTHOG_KEY__";
  if (typeof window !== "undefined" && btoa(POSTHOG_KEY) !== "X19QT1NUSE9HX0tFWV9f") {
    posthog.init(POSTHOG_KEY, {
      // Uncomment the following line to use a custom API host
      // api_host: document.location.protocol + "//" + document.location.host + "/ph-metrics",
      api_host: "https://eu.i.posthog.com",
      person_profiles: "identified_only",
      autocapture: false,
      disable_session_recording: true,
    });
  }
};

export const login = () => {
  capture("logout");
};
export const logout = () => {
  capture("logout");
};

export const sessionTimeout = () => {
  capture("session_timeout");
};

export const evidenceShow = () => {
  capture("evidence_show");
};

const capture = (eventName: string, params?: Properties | null | undefined) => {
  try {
    posthog.capture(eventName, params);
  } catch (error) {
    console.error("Error capturing event:", error);
  }
};
